export const services = Object.freeze({
  NODE_ENDPOINT_GET_ALL_FILES: "maxappsDesigner/getAllFilesVersion",
  NODE_ENDPOINT_ADD_FILE: "maxappsDesigner/addNewVersion",
  NODE_ENDPOINT_GET_FILE_CONTENT: "maxappsDesigner/getFileContent",
  NODE_ENDPOINT_DELETE_FILE: "maxappsDesigner/deleteFile",
  NODE_ENDPOINT_EDIT_XML_ALIAS: "maxappsDesigner/editXmlAlias",
  NODE_ENDPOINT_UPDATE_FILE_CONTENT: "maxappsDesigner/updateFileContent",
});
